import {handleActions} from 'redux-actions';
import {
    MEDIA_ORDERS_ITEM_SET,
    MEDIA_ORDERS_ITEM_RESET,
    MEDIA_ORDERS_ITEM_SORT,
} from './MediaOrdersItemActions';
import {checkForNullAndFormat} from 'QCWorkflow/QCManager/Redux/QCManagerReducer';
import {
    MediaOrdersItemType,
    MediaOrdersItemStateType,
    MediaOrdersItemPayloadType,
} from '../../MediaOrdersTypes';

const DATE_FORMAT = 'MM/dd/yyyy';

export const formatRow = (row: MediaOrdersItemType) => {
    const {dueDateToLab, dueDateToPluto, ...rest} = row;
    return {
        ...rest,
        dueDateToLab: checkForNullAndFormat(dueDateToLab, DATE_FORMAT),
        dueDateToPluto: checkForNullAndFormat(dueDateToPluto, DATE_FORMAT),
    };
};

export const setItem = (
    state: MediaOrdersItemStateType,
    {payload}: MediaOrdersItemPayloadType
) => {
    if (payload) {
        const {rows = [], total = 0} = payload;
        return {
            rows: rows.map(formatRow),
            total: total,
        };
    }
    return state;
};

export const resetItem = () => {
    return initialState;
};

const initialState = {
    rows: [],
    total: 0,
};

const handlers = {
    [MEDIA_ORDERS_ITEM_SET]: setItem,
    [MEDIA_ORDERS_ITEM_SORT]: setItem,
    [MEDIA_ORDERS_ITEM_RESET]: resetItem,
};

export default handleActions(handlers, initialState);
